import { useMemo } from 'react';

import useDispatchAction from '@/hooks/useDispatchAction';
import { getProviderPayingAccountsAction } from '@/domain/paySettings';

const useGetAccounts = (providerId: string) => {
  const payload = useMemo(() => ({ id: providerId }), [providerId]);

  const { data = [], isLoading, setData } = useDispatchAction(getProviderPayingAccountsAction, payload, []);

  return { isLoading, data, setData };
};

export default useGetAccounts;
